import { css } from 'aphrodite';
import * as React from 'react';
import { Noop } from '../../models';
import { logEvent } from '../../models/Analytics';
import { styleSheet } from './styles';
import './styles.less';

interface IProps {
	className?: string;
}

interface IState {
	loading?: boolean;
	showingMessenger?: boolean;
	unreadMessagesCount?: number;
}

// tslint:disable:max-line-length

export class IntercomLauncher extends React.Component<IProps, IState> {
	private mDidMount: boolean;
	public readonly state: IState = {
		loading: true,
		unreadMessagesCount: 0,
	};

	public componentDidMount() {
		this.mDidMount = true;
		const containerNode = document.getElementById('intercom-container');
		if (!!containerNode) {
			this.init(containerNode);
		} else {
			// add mount listeners
			if (!!document) {
				document.addEventListener('animationstart', this.onAnimationStarted as any, true);
				document.addEventListener('MSAnimationStart', this.onAnimationStarted as any, true);
				document.addEventListener('webkitAnimationStart', this.onAnimationStarted as any, true);
			}
		}
	}

	public componentWillUnmount() {
		if (!!window && !!this.mDidMount) {
			if (!!document) {
				document.removeEventListener('animationstart', this.onAnimationStarted as any, true);
				document.removeEventListener('MSAnimationStart', this.onAnimationStarted as any, true);
				document.removeEventListener('webkitAnimationStart', this.onAnimationStarted as any, true);
			}

			if (!!window.hasOwnProperty('Intercom')) {
				// used Noop here because intercom crashes if you supply null
				Intercom('onUnreadCountChange', Noop);
				Intercom('onHide', Noop);
				Intercom('onShow', Noop);
			}
		}

		this.mDidMount = false;
	}

	public render() {
		const { className } = this.props;
		const { showingMessenger, loading, unreadMessagesCount } = this.state;
		return (
			<div
				className={ `${ css(styleSheet.container, !!loading ? null : styleSheet.containerActive) } component-class ${ className || '' }` }
				onClick={ this.onClick }
				tabIndex={ 0 }
			>
				<div className={ css(styleSheet.containerContent) }>
					<svg
						className={ css(styleSheet.icon, styleSheet.openIcon, !!showingMessenger ? null : styleSheet.iconActive) }
						height={ 32 }
						viewBox='0 0 28 32'
						width={ 28 }
					>
						<path d='M28,32 C28,32 23.2863266,30.1450667 19.4727818,28.6592 L3.43749107,28.6592 C1.53921989,28.6592 0,27.0272 0,25.0144 L0,3.6448 C0,1.632 1.53921989,0 3.43749107,0 L24.5615088,0 C26.45978,0 27.9989999,1.632 27.9989999,3.6448 L27.9989999,22.0490667 L28,22.0490667 L28,32 Z M23.8614088,20.0181333 C23.5309223,19.6105242 22.9540812,19.5633836 22.5692242,19.9125333 C22.5392199,19.9392 19.5537934,22.5941333 13.9989999,22.5941333 C8.51321617,22.5941333 5.48178311,19.9584 5.4277754,19.9104 C5.04295119,19.5629428 4.46760991,19.6105095 4.13759108,20.0170667 C3.97913051,20.2124916 3.9004494,20.4673395 3.91904357,20.7249415 C3.93763774,20.9825435 4.05196575,21.2215447 4.23660523,21.3888 C4.37862552,21.5168 7.77411059,24.5386667 13.9989999,24.5386667 C20.2248893,24.5386667 23.6203743,21.5168 23.7623946,21.3888 C23.9467342,21.2215726 24.0608642,20.9827905 24.0794539,20.7254507 C24.0980436,20.4681109 24.0195551,20.2135019 23.8614088,20.0181333 Z'/>
					</svg>
					<svg
						className={ css(styleSheet.icon, styleSheet.closeIcon, !!showingMessenger ? styleSheet.iconActive : null) }
						height={ 14 }
						viewBox='0 0 14 14'
						width={ 14 }
					>
						<path
							d='M13.978 12.637l-1.341 1.341L6.989 8.33l-5.648 5.648L0 12.637l5.648-5.648L0 1.341 1.341 0l5.648 5.648L12.637 0l1.341 1.341L8.33 6.989l5.648 5.648z'
							fillRule='evenodd'
						/>
					</svg>
					<div className={ css(styleSheet.badge, unreadMessagesCount > 0 ? styleSheet.badgeActive : null) }>
						{ unreadMessagesCount }
					</div>
				</div>
			</div>
		);
	}

	private onClick = () => {
		if (!!window.hasOwnProperty('Intercom')) {
			Intercom(!!this.state.showingMessenger ? 'hide' : 'show');
		}
	}

	private init = (_: HTMLElement) => {
		if (!!window.hasOwnProperty('Intercom')) {
			Intercom('onUnreadCountChange', this.onUnreadCountChange);
			Intercom('onHide', this.onHide);
			Intercom('onShow', this.onShow);
			this.setState({
				loading: false,
			});
		}
	}

	private onHide = () => {
		logEvent('IntercomLauncher', 'HideMessenger');
		if (!!this.state.showingMessenger) {
			this.setState({
				showingMessenger: false,
			});
		}
	}

	private onShow = () => {
		logEvent('IntercomLauncher', 'ShowMessenger');
		if (!this.state.showingMessenger) {
			this.setState({
				showingMessenger: true,
			});
		}
	}

	private onUnreadCountChange = (count: number) => {
		this.setState({
			unreadMessagesCount: count || 0,
		});
	}

	private onAnimationStarted = (e: React.AnimationEvent<HTMLElement>) => {
		if (e.animationName === 'IntercomContainerInserted') {
			this.init(e.target as HTMLElement);
		}
	}
}
